export const userConstants = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    AVATAR_UPLOAD_REQUEST: 'AVATAR_UPLOAD_REQUEST',
    AVATAR_UPLOAD_SUCCESS: 'AVATAR_UPLOAD_SUCCESS',
    AVATAR_UPLOAD_FAILURE: 'AVATAR_UPLOAD_FAILURE',
}